import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { IComment } from '@app/api/interfaces/comment.interface';
import { IFpLoggerNoiseData } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-data';

export enum FpLoggerNoiseCommentsActionType {
  GetData = 'GetData',
  GetDataSuccesses = 'GetDataSuccesses',
  SaveComment = 'SaveComment',
  SaveCommentSuccess = 'SaveCommentSuccess',
  SaveCommentError = 'SaveCommentError',
}

export interface FpLoggerNoiseCommentsActionGetData {
  type: FpLoggerNoiseCommentsActionType.GetData;
  date: string | null;
  popupMainData: IFpLoggerNoiseData | null;
}

export interface FpLoggerNoiseCommentsActionGetDataSuccesses {
  type: FpLoggerNoiseCommentsActionType.GetDataSuccesses;
  date: string | null;
  data: IFpLoggerNoiseData | null;
}

export interface FpLoggerNoiseCommentsActionSaveComment {
  type: FpLoggerNoiseCommentsActionType.SaveComment;
  content: string;
}

export interface FpLoggerNoiseCommentsActionSaveCommentSuccess {
  type: FpLoggerNoiseCommentsActionType.SaveCommentSuccess;
  comment: IComment;
}

export interface FpLoggerNoiseCommentsActionSaveCommentError {
  type: FpLoggerNoiseCommentsActionType.SaveCommentError;
  error: IApiBaseErrorResponse;
}

export type FpLoggerNoiseCommentsActions =
  | FpLoggerNoiseCommentsActionGetData
  | FpLoggerNoiseCommentsActionGetDataSuccesses
  | FpLoggerNoiseCommentsActionSaveComment
  | FpLoggerNoiseCommentsActionSaveCommentSuccess
  | FpLoggerNoiseCommentsActionSaveCommentError;
